import { useQuery } from '@tanstack/react-query';
import { GET_CONTEXT_INSIGHT_PERIODS } from '../../query/context-insights/keys';
import {
  getContextInsightPeriods,
  InsightPeriodRange,
} from '../../services/context-insights/ContextInsightsService';

export const useGetContextInsightPeriods = (projectId: number | null) => {
  const query = useQuery<InsightPeriodRange[]>({
    queryKey: [GET_CONTEXT_INSIGHT_PERIODS, projectId],
    queryFn: () => {
      if (!projectId) throw new Error('projectId is required');
      return getContextInsightPeriods(projectId);
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
  });

  return {
    insightPeriods: query.data ?? [],
    isLoading: query.isLoading,
  };
};